module.exports = __webpack_public_path__ + "img/744.c4edfd06.jpg";